import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createUserAnswerSchemas } from 'shared/db/validation/schemas/userAnswer';
import { Validator } from 'shared/db/validation/validator';
import { DeleteRawRecord, UpdateRawRecord } from 'shared/types/rawRecordFields';
import { UserAnswerRawRecord } from 'shared/types/userAnswer';
import { UserAnswerDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createUserAnswerSchemas();

const addValidator = createDBEntityValidator<UserAnswerRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<
    UpdateRawRecord<UserAnswerRawRecord>
>(schemas.update);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-user-answers'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createUserAnswersInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const userAnswersInputValidation: UserAnswerDBValidation = {
    add: createUserAnswersInputValidation(addValidator, validationStrategy),
    update: createUserAnswersInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createUserAnswersInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
